export default __webpack_public_path__ + "static/media/IMG_5348.950ebb3f.jpg";